import { Component, OnInit } from '@angular/core'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { PortalGlobals } from '../../../../app/portalglobals'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { Router } from '@angular/router'
import { UserDataService } from '../../../user-management/gateways/user-data-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import * as moment from 'moment'
import { UtilsService } from '../common/utils-service'
import { AuthService } from '../../../auth/auth-service'

@Component({
    selector: 'enrollments',
    templateUrl: './enrollments.component.html'
})
export class Enrollments implements OnInit {
    isViewPage: boolean = false
    public currentUser: CurrentUser = {} as CurrentUser
    IsPhoneEnrollmentAccess: boolean
    isPhoneView: boolean
    phoneEnrollmentURL: string
    NEJEView: boolean
    viewAfterLogic:boolean

    constructor(
        private router: Router,
        public portalGlobal: PortalGlobals,
        private _networkUserAccessGateway: UserAccessGateway,
        private _authService: AuthService,
        private _enrollementGateway: EnrollmentGateway,
        private userdataservice: UserDataService
    ) {
        this.isPhoneView = false
        this.viewAfterLogic = false
    }
    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this.currentUser = JSON.parse(User!)
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()

        this._authService.isAuthorization('enrollmentInfo')

        //   this.setPlanYear()
        if (this.portalGlobal.selectedPlanYear === undefined || this.portalGlobal.selectedPlanYear === 0) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this.portalGlobal.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
                if (this.portalGlobal.selectedPlanYear === undefined || this.portalGlobal.selectedPlanYear === 0)
                    this.portalGlobal.selectedPlanYear = Number(localStorage.getItem('PLANYEAR'))

                this.userdataservice.changeSelectedYear(this.portalGlobal.selectedPlanYear)

                if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI) this.CheckPhoneEnrllAccess(this.currentUser)
                else this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
            } else {
                this.loadPlanYears(true)
            }
        } else {
            if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI) this.CheckPhoneEnrllAccess(this.currentUser)
            else this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
        }
        //this.Navigatation()
    }

    RedirectURL(currentUser: CurrentUser) {
        this.setPlanYear()
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()

        if (currentUser.IsSuperAdminAdmin || currentUser.IsGuruAdmin) {
            this.isPhoneView = true
            this.isViewPage = true
            this.viewAfterLogic = true
        } else {
            if (currentUser.IsAgent && this.isPhoneView === false) {
                console.log('IsAgent user: ' + currentUser)
                this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1'])
                this.viewAfterLogic = true
            } else {
                if (currentUser.IsDataEntrySpecialist || currentUser.IsDataEntryGroupSpecialist) {
                    console.log('IsDataEntrySpecialist user: ' + currentUser)
                    this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
                    
                } else {
                    if (currentUser.isCallCenterAgent) {
                        console.log('isCallCenterAgent user: ' + currentUser)
                        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step1/0/' + this.portalGlobal.selectedPlanYear])
                    }
                }
            }
        }
      
    }

    CheckPhoneEnrllAccess(currentUser: CurrentUser) {
        if (currentUser.insuranceCompanyId !== undefined && currentUser.roleId !== undefined) {
            const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
            this._enrollementGateway
                .GetPhoneEnrollmentAcccessCheck(parseInt(currentUser.orgId), currentUser.roleId.toString())
                .subscribe((model: any) => {
                    if (model !== null) {
                        this.IsPhoneEnrollmentAccess = model
                        this.isPhoneView = this.IsPhoneEnrollmentAccess
                        this.RedirectURL(currentUser)
                        if (this.IsPhoneEnrollmentAccess) {
                            this.phoneEnrollmentURL = '/' + insCo + '/enrollment/phone-enrollment/ext/Step1'
                        } else {
                            this.phoneEnrollmentURL = '/' + insCo + '/enrollment/phone-enrollment/Step1/0/' + this.portalGlobal.selectedPlanYear
                        }
                    }
                })
        }
        
    }

    RedirectPhoneEnrollment() {
        this.router.navigate([this.phoneEnrollmentURL])
    }
    setPlanYear() {
        if (this.portalGlobal.selectedPlanYear === undefined || this.portalGlobal.selectedPlanYear === 0) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this.portalGlobal.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
                this.userdataservice.changeSelectedYear(this.portalGlobal.selectedPlanYear)
                if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI) this.CheckPhoneEnrllAccess(this.currentUser)
            } else {
                this.loadPlanYears(true)
            }
        }
        
    }

    loadPlanYears(isCheckPhoneEnrollAccess: boolean) {
        const insCo = this.currentUser.insuranceCompanyShortName.toLowerCase()
        this._networkUserAccessGateway.getCurrentPlanYears().subscribe(
            (planYears) => {
                this.portalGlobal.availablePlanYears = planYears
                // this.planyears = this.portalGlobal.availablePlanYears
                if (planYears !== null) {
                    if (planYears.length > 1) {
                        // making the max logic eloborate so that if we change planyears
                        // from number to a complex object its easy to accomodate.
                        var planYearStr: any
                        planYearStr = sessionStorage.getItem('PLANYEAR')
                        if (planYearStr === null || planYearStr === 0) {
                            let currentyear = moment().get('year')
                            if (currentyear === planYears[0]) this.portalGlobal.selectedPlanYear = planYears[0]
                            else if (currentyear === planYears[1]) this.portalGlobal.selectedPlanYear = planYears[1]
                            else this.portalGlobal.selectedPlanYear = planYears[0]
                        } else {
                            this.portalGlobal.selectedPlanYear = Number(planYearStr)
                        }
                    } else {
                        this.portalGlobal.selectedPlanYear = planYears[0]
                    }
                    this.userdataservice.changeAvailableYears(planYears)
                    this.userdataservice.changeSelectedYear(this.portalGlobal.selectedPlanYear)
                    if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI) {
                        if (isCheckPhoneEnrollAccess) {
                            this.CheckPhoneEnrllAccess(this.currentUser)
                        }
                    } else this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
                }
               
            },
            (error) => {}
        )
    }

    //Navigatation() {
    //    if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameSSI)
    //        this.NEJEView = false
    //    else if (this.currentUser.insuranceCompanyName === this.portalGlobal.insuranceCompanyNameNEJE)
    //        this.NEJEView = true

    //}
}
